import { Form, Formik, FormikHelpers, FormikProps, getIn } from 'formik';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import DatePickerCustom from '../../../component/date-picker/DatePickerCustom';
import { IconBack, IconButtonSave } from '../../../component/IconSvg';
import InputAutoComplete from '../../../component/input-autocomplete';
import LabelRequired from '../../../component/LabelRequired';
import { OctNumberField } from '@oceantech/oceantech-ui';
import { TableCustom } from '../../../component/table/table-custom/TableCustom';
import TextField from '../../../component/TextField';
import InfoPatientRight from '../../../phan-he-kham-benh/components/InfoPatientRight';
import { ThuocColumns } from '../../../phan-he-kham-benh/components/modal-tab-thuoc/ThuocColumns';
import ProvisonalDiagnosis from '../../../phan-he-kham-benh/components/ProvisonalDiagnosis';
import SelectTableButton from '../../../phan-he-kham-benh/components/select-thuoc-button';
import {
	CHI_PHI_THUOC_FIELDS,
	CHI_PHI_THUOC_TYPE,
	DRUG_WAREHOUSE_FORM_MAPPER,
	HDSD_THUOC_OPTIONS,
	LIEU_DUNG_THUOC_OPTIONS,
	THOI_DIEM_DUNG_THUOC,
	WAREHOUSE_HANDLER_TYPE,
	WAREHOUSE_TYPE,
} from '../../../phan-he-kham-benh/constants/Thuoc';
import NgayKeTuDong from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
import { ThuocInfo } from '../../../phan-he-kham-benh/models/DSBenhNhanKhamBenhModels';
import { IKeThuocRequest, IKeThuocThongTinChung, IKhoThuoc, IThoiDiemDung, IThuoc, IThuocModel } from '../../../phan-he-kham-benh/models/ThuocModels';
import PaymentInfor from '../../../phan-he-vien-phi/components/PaymentInfor';
import { formatDateDTO, formatDateTime, formatMoney, getErrorMessage, parseJSON } from '../../../utils/FormatUtils';
import { useContext, useEffect, useRef, useState } from 'react';
import { IDanhSachDanhMuc } from '../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { getIndexedDBItem } from '../../../utils/IndexedDB';
import { APP_TIMESTAMP_FORMAT, CODE, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../utils/Constant';
import ICD10 from '../../../phan-he-kham-benh/components/ICD10';
import CustomIconButton from '../../../component/custom-icon-button/CustomIconButton';
import { searchVatTu } from '../../../phan-he-kham-benh/services/VatTuService';
import { LOAI_VAT_TU } from '../../../phan-he-kham-benh/constants/VatTu';
import { toast } from 'react-toastify';
import { TableCustomHeader } from '../../../component/table/components/TableCustomHeader';
import { ConfirmDialog } from '../../../component/ConfirmDialog';
import { getDsPhieuDieuTri } from '../../services/BenhAnServices';
import { usePhanHeDieuTriNoiTruContext } from '../../PhanHeDieuTriContext';
import { localStorageItem } from '../../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from '../../../auth/core/_consts';
import * as Yup from "yup";
import { useIntl } from 'react-intl';
import { Row as ReactTableRowProps } from 'react-table';
import { AppContext } from '../../../appContext/AppContext';
import moment from 'moment';
import { getFormFieldConfig, getPaymentDetail } from '../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import { fetchKeThuoc, updateKeThuoc } from '../../services/DieuTriServices';
import { handleConvertBenhNhanInfo } from '../../../phan-he-noi-tru/common/functionCommon';
import { usePhanHeNoiTruContext } from '../../../phan-he-noi-tru/PhanHeNoiTruContext';
import PhieuDieuTriDialog from '../benh-an/components/content/components/thong-tin-benh-an/components/phieu-dieu-tri/components/PhieuDieuTriDialog';
import { getBirthdayDrugParam, getPriceByObjectType } from '../../../phan-he-kham-benh/modals/modal-ke-thuoc/utils';
import { getWarehouse } from '../../../phan-he-kham-benh/services/ThuocService';
import useIndexDBValue from '../../../../hook/useIndexDBValue';
import { getCellEditValue } from '../../../phan-he-kham-benh/modals/modal-ke-vat-tu/common';
import { getWarehouseProcess } from '../../../utils/ServicesUtils';
import { ServiceTemplateButton } from 'src/app/modules/phan-he-kham-benh/components/service-template-button';
import HeaderThuoc from './HeaderThuoc';

type Props = {
	open: boolean;
	onClose: () => void;
	phieuDieuTri?: any;
	itemEdit?: any;
	callbackFunc?: () => void;
};

const FormChiDinhThuoc = ({ open, onClose, phieuDieuTri, itemEdit, callbackFunc }: Props) => {
	const intl = useIntl();
	const { setIsLoading } = useContext(AppContext);

	const formRef = useRef<HTMLFormElement>(null);
	const formikRef = useRef<FormikProps<IThuocModel & {
		autoPrescriptions?: any[],
		treatmentSheet?: any,
		usageFrom?: string,
		usageTo?: string
	}>>(null);
	const rowSelectedRef = useRef<any>(null);
	const khoThuocIdRef = useRef<number>();
	const deletedListRef = useRef<Map<string, any>>(new Map());
	
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { statusChangedEventFunc } = usePhanHeNoiTruContext();
	const [danhSachKhoThuoc, setDanhSachKhoThuoc] = useState<IKhoThuoc[]>([]);
	const [khoThuocSelected, setKhoThuocSelected] = useState<IKhoThuoc>();
	const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
		key: KEY_DS_DANH_MUC_TIEP_DON,
	});
	const [thuocSelected, setThuocSelected] = useState<Partial<IThuoc>>();
	const [tableData, setTableData] = useState<ThuocInfo[]>([]);

	const [listComorbidity, setListComorbidity] = useState<any[]>([]);
	const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
	const [openPhieuDieuTriDialog, setOpenPhieuDieuTriDialog] = useState<boolean>(false);
	const [openConfirmDelete, setOpenConfirmDelete] = useState<boolean>(false);
	const [thuocDetail, setThuocDetail] = useState<any>();
	const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] = useState<boolean>(false);
	const [validateMessage, setValidateMessage] = useState<string>("");
	const [inventoryValidateMessage, setInventoryValidateMessage] = useState<string[] | null>(null);
	const [paymentItem, setPaymentItem] = useState<any>([]);
	const [dsPhieuDieuTri, setDsPhieuDieuTri] = useState<any[]>([]);
	const [thongTinChiPhi, setThongTinChiPhi] = useState<any>({
		tongChiPhi: 0,
		bhyt: 0,
		benhNhan: 0,
		tamUng: 0,
		daThu: 0,
		mienGiam: 0,
		conDu: 0,
	});
	const userMetaData = localStorageItem.get(KEY_LOCALSTORAGE.USER_METADATA);

	const initialThuocInfoValue = {
		idThuoc: '',
		maThuoc: '',
		tenThuoc: '',
		actIngName: '',
		soLuongKhaDung: 0,
		donViTinh: '',
		duongDung: '',
		soNgayDung: 0,
		quantityInMorning: 0,
		quantityInNoon: 0,
		quantityInAfternoon: 0,
		quantityInEvening: 0,
		tongSoThuoc: 0,
		lieuDung: '',
		huongDanSuDungThuoc: '',
		index: undefined,
	};

	const { visitObjectTypeCode } = benhNhanDieuTri;
	const userInfo = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
	const validationSchema = Yup.object().shape({
		lieuDung: Yup.string().required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' })),
		tongSoThuoc: Yup.number()
			.required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' }))
			.min(1, intl.formatMessage({ id: 'VALIDATION.REQUIRE' }))
			.when('soLuongKhaDung', (soLuongKhaDung, schema) => {
				return schema.max(
					soLuongKhaDung ?? 0,
					'Số lượng thuốc kê đơn không lớn hơn số lượng thuốc khả dụng'
				);
			}),
	});

	const initialFormValues: IThuocModel & {
		autoPrescriptions?: any[],
		treatmentSheet?: any,
		usageFrom?: string,
		usageTo?: string
	} = {
		ngayYLenh: formatDateDTO(phieuDieuTri?.prescriptionDate) ?? '',
		treatmentSheet: phieuDieuTri,
		ghiChu: '',
		khoThuoc: '',
		bacSiDieuTri: userInfo.name,
		loiDanBacSi: '',
		dotDung: '',
		ngayTaiKham: '',
		ngayKeTuDong: '',
		provisionalDiagnosis: benhNhanDieuTri?.icd10ProvisionalDiagnosisCode,
		provisionalDiagnosisName: benhNhanDieuTri?.icd10ProvisionalDiagnosisName,
		comorbidity: benhNhanDieuTri?.icd10ProvisionalComorbidity,
		...initialThuocInfoValue,
	};
	const tongTienDonThuoc = tableData.reduce((acc: number, row: ThuocInfo) => {
		return acc + (row.thanhTien || 0);
	}, 0);
	const tongTienConDu = Math.abs(thongTinChiPhi.tamUng + thongTinChiPhi.daThu - (thongTinChiPhi.benhNhan + tongTienDonThuoc));

	const handleGetThongTinChiPhi = async () => {
		try {
			const { data } = await getPaymentDetail(benhNhanDieuTri?.visitId);
			if (CODE.SUCCESS === data?.code) {
				setThongTinChiPhi({
					tongChiPhi: data?.data?.ttTong,
					bhyt: data?.data?.ttBhyt,
					benhNhan: data?.data?.ttNguoiBenh,
					tamUng: data?.data?.ttTamUng,
					daThu: data?.data?.ttDaThu,
					mienGiam: data?.data?.ttDiscountInv,
					conDu: data?.data?.ttConNo,
				});
			}
		} catch (error) {
			console.error(error);
			toast.error('Xảy ra lỗi khi lấy thống tin chi phi, vui lòng thử lại!');
		}
	}

	useEffect(() => {
		getKhoThuoc();
		handleGetThongTinChiPhi();
	}, []);

	useEffect(() => {
		if (thuocSelected?.id && formikRef.current) {
			for (const [formKey, warehouseKey] of Object.entries(DRUG_WAREHOUSE_FORM_MAPPER)) {
				formikRef.current.setFieldValue(
					formKey,
					thuocSelected[warehouseKey as keyof IThuoc]
				);
			}
		}
	}, [thuocSelected]);

	useEffect(() => {
		if (danhSachKhoThuoc.length && thuocDetail?.id) {
			setKhoThuocSelected(getDetailKhoThuocSelected(thuocDetail?.warehouseId));
		}
	}, [danhSachKhoThuoc.length, thuocDetail?.id]);

	const getKhoThuoc = async () => {
		try {
			let formCode = REQUEST_FROM.DIEU_TRI;
			let medicalItemTypeCode = REQUEST_TYPE.THUOC;
			const resWarehouseProcess = await getWarehouseProcess({
				formCode,
				medicalItemTypeCode,
				visitObjectTypeCode
			});
			if (resWarehouseProcess?.data) {
				const { data } = await getWarehouse({
					warehousePrescriptions: resWarehouseProcess?.data,
				});
				setDanhSachKhoThuoc(data?.content ?? []);
				if (data.length === 1) {
					setKhoThuocSelected(data[0]);
					khoThuocIdRef.current = data[0].id;
				}
			} else {
				toast.error('Không tìm thấy cấu hình luồng kho');
				setDanhSachKhoThuoc([]);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const onDrugSelect = (selectedDrug: any) => {
		if (!selectedDrug) {
			return;
		}

		const isExistSelectedDrug = tableData.some((row: any) =>
			row.maThuoc === selectedDrug?.code && row?.consignment === selectedDrug?.consignment
		);

		if (isExistSelectedDrug) {
			toast.warn(`Thuốc "${selectedDrug.name}" đã được kê trong đơn này`);
			return;
		}

		setThuocSelected(selectedDrug);
	}

	const handleSubmit = async (values: IThuocModel, formHelpers: FormikHelpers<any>) => {
		if (!values.tenThuoc) {
			toast.warning('Chưa chọn thuốc kê đơn');
			return;
		}

		const isKhoNhaThuoc = WAREHOUSE_TYPE.NORMAL === khoThuocSelected?.warehouseType;
		const donGiaThuoc = isKhoNhaThuoc
			? (thuocSelected?.salePrice || 0)
			: getPriceByObjectType(
				thuocSelected, 
				values?.visitObjectTypeCode ?? benhNhanDieuTri?.visitObjectTypeCode
			);
		const objectType = danhSachDanhMuc?.listDoiTuong.find(
				record => record.code === benhNhanDieuTri?.visitObjectTypeCode
			);

		const rowData: any = {
			...thuocSelected,
			...values,
			id: values?.tableRowId,
			maThuoc: values.maThuoc,
			tenThuoc: values.tenThuoc,
			hoatChat: values.actIngName,
			donVi: thuocSelected?.unitofMeasureName || values.donViTinh,
			soLuong: values.tongSoThuoc || 0,
			soLuongKhaDung: values.soLuongKhaDung || thuocSelected?.iventory || 0,
			duongDung: values.duongDung || thuocSelected?.roa,
			lieuDung: values.lieuDung,
			huongDanSuDungThuoc: values.huongDanSuDungThuoc,
			donGia: donGiaThuoc,
			thanhTien:
				thuocSelected && values.tongSoThuoc
					? donGiaThuoc * values.tongSoThuoc
					: 0,
			doiTuong: benhNhanDieuTri?.visitObjectTypeName,
			serialNumber: thuocSelected?.serialNumber,
			materialType: thuocSelected?.materialType,
			materialTypeName: thuocSelected?.materialTypeName,
			dosageStrength: thuocSelected?.dosage,
			consignment: thuocSelected?.consignment,
			percentIns: thuocSelected?.rateHealthInsurance || values?.percentIns,
			routeCode: thuocSelected?.ROA || values?.routeCode,
			quantityInMorning: values?.quantityInMorning,
			quantityInNoon: values?.quantityInNoon,
			quantityInAfternoon: values?.quantityInAfternoon,
			quantityInEvening: values?.quantityInEvening,
			visitObjectTypeId: objectType.id,
			visitObjectTypeName: objectType.name,
			visitObjectTypeCode: objectType.code,
			objectTypeId: values.objectTypeId ?? objectType.id,
			objectTypeCode: values.objectTypeCode ?? objectType.code,
			objectTypeName: values.objectTypeName ?? objectType.name,
		};

		let tableDataTemp = [...tableData];
		const drugExist = tableData.some((row: any) => (row.maThuoc === rowData.maThuoc && row?.consignment === rowData?.consignment));

		if (!drugExist) {
			tableDataTemp.push(rowData);
		} else {
			tableDataTemp = tableData.map((row: any) => {
				if (row.maThuoc === rowData.maThuoc && row?.consignment === rowData?.consignment) {
					return {
						...row,
						...rowData,
					};
				}
				return row;
			});
		}

		setTableData(tableDataTemp.map((row, index) => ({ ...row, index })));
		formHelpers.resetForm({
			values: {
				...values,
				...initialThuocInfoValue,
			},
		});
	};

	const countTongSoLuongThuoc = (formValues: IThuocModel) => {
		if (!formValues.soNgayDung || isEmptyLieuDungThuoc(formValues)) {
			formikRef.current?.setFieldValue('tongSoThuoc', '');
			return;
		}

		const lieuDungThuocTrenNgay = getTongSoThuocTrenNgay(formValues);
		const tongSoThuoc = formValues.soNgayDung * lieuDungThuocTrenNgay;
		formikRef.current?.setFieldValue('tongSoThuoc', tongSoThuoc);
	};

	const getTongSoThuocTrenNgay = (values: IThuocModel) => {
		return (
			(Number(values.quantityInMorning) || 0) +
			(Number(values.quantityInNoon) || 0) +
			(Number(values.quantityInAfternoon) || 0) +
			(Number(values.quantityInEvening) || 0)
		);
	};

	const isEmptyLieuDungThuoc = (values: IThuocModel) => {
		return [
			values.quantityInMorning,
			values.quantityInNoon,
			values.quantityInAfternoon,
			values.quantityInEvening,
		].every(item => !Boolean(item));
	};

	const getChiPhiThuocValue = (field: CHI_PHI_THUOC_TYPE) => {
		const MAP_FIELD_VALUE = {
			[CHI_PHI_THUOC_FIELDS.TIEN_DON]: tongTienDonThuoc,
			[CHI_PHI_THUOC_FIELDS.TONG_CHI_PHI]: thongTinChiPhi.tongChiPhi + tongTienDonThuoc,
			[CHI_PHI_THUOC_FIELDS.BHYT]: thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.NGUON_KHAC]: 0,
			[CHI_PHI_THUOC_FIELDS.BENH_NHAN]:
				thongTinChiPhi.benhNhan + tongTienDonThuoc - thongTinChiPhi.bhyt,
			[CHI_PHI_THUOC_FIELDS.TAM_UNG]: thongTinChiPhi.tamUng,
			[CHI_PHI_THUOC_FIELDS.DA_THU]: thongTinChiPhi.daThu,
			[CHI_PHI_THUOC_FIELDS.MIEN_GIAM]: thongTinChiPhi.mienGiam,
			[CHI_PHI_THUOC_FIELDS.CON_DU]:
				thongTinChiPhi.tamUng +
				thongTinChiPhi.daThu -
				(thongTinChiPhi.benhNhan + tongTienDonThuoc),
		};

		return formatMoney(MAP_FIELD_VALUE[field] || 0);
	};
	
	const validateInventoryForAutoPrescriptions = (
		drugs: ThuocInfo[],
		autoPrescriptions: any[]
	): { isValid: boolean; errorMessages: string[] } => {
		const totalDays = 1 + (autoPrescriptions?.length || 0); // Ngày chính + các ngày kê tự động
		const errorMessages: string[] = [];

		for (const drug of drugs) {
			const tongSoThuoc = drug.soLuong || 0;
			const soLuongKhaDung = drug.soLuongKhaDung || 0;
			const totalRequired = tongSoThuoc * totalDays;

			if (totalRequired > soLuongKhaDung) {
				errorMessages.push(
					`[${drug.tenThuoc}] - SL cần: ${totalRequired} (${tongSoThuoc} × ${totalDays} ngày), SL khả dụng: ${soLuongKhaDung}`
				);
			}
		}

		return {
			isValid: errorMessages.length === 0,
			errorMessages
		};
	};

	const onSaveForm = async () => {
		try {
			const hasDrugData = tableData.length;
			const formValues = formikRef.current?.values;

			if (!formValues?.treatmentSheet) {
				toast.warn('Chưa chọn phiếu điều trị');
				return;
			}

			if (!formValues?.provisionalDiagnosisName && !formValues?.diagnosisNonCoded) {
				toast.warn('Chưa nhập thông tin chẩn đoán!');
				return;
			}

			if (!hasDrugData) {
				toast.warn('Hiện tại chưa có thuốc được kê cho đơn này');
				return;
			}

			// Validate số lượng khả dụng khi có kê tự động
			const autoPrescriptionsData = formValues?.autoPrescriptions || [];
			if (autoPrescriptionsData.length > 0) {
				const inventoryValidation = validateInventoryForAutoPrescriptions(
					tableData,
					autoPrescriptionsData
				);
				if (!inventoryValidation.isValid) {
					setInventoryValidateMessage(inventoryValidation.errorMessages);
					return;
				}
			}

			setIsLoading(true);
			const listThuoc: IKeThuocRequest[] = [];

			tableData.forEach((row: any) => {
				listThuoc.push({
					...row,
					visitId: row.visitId || benhNhanDieuTri?.visitId,
					medicalItemId: String(row.idThuoc) || row.medicalItemId,
					medicalItemCode: row.maThuoc || row.medicalItemCode,
					name: row.tenThuoc,
					dosageForm: row.dosage || row.lieuDung,
					route: row.duongDung,
					usageInstructions: row.huongDanSuDungThuoc,
					unit: row.donVi,
					activeIngredients: row.hoatChat,
					numberOfDays: row.soNgayDung,
					totalQuantity: row.tongSoThuoc,
					unitPrice: row.donGia,
					intoMoney: row.thanhTien,
					orderTypeId: parseInt(ORDER_TYPE_ID.THUOC),
					patientId: benhNhanDieuTri?.patientId,
					orderId: row.orderId,
					svcFee: row.servicePrice, 
					svcFeeIns: row.bhytPrice, 
					svcFeeHospital: row.hospitalPrice,
				});
			});

			const { lstMedicalItemOrderRes, ...detailOtherValues } = thuocDetail || {};

			let autoPrescriptions = formValues?.autoPrescriptions?.map((item: any) => ({
				prescriptionDate: item?.value,
				treatmentSheetId: item?.treatmentSheetId,
			})) || [];
			const donThuocRequest: IKeThuocThongTinChung = {
				...detailOtherValues,
				treatmentSheetId: formValues?.treatmentSheet?.id || phieuDieuTri?.id,
				doctorOrderDay: formValues?.ngayYLenh || thuocDetail?.doctorOrderDay,
				note: formValues?.ghiChu,
				warehouseName: formValues?.khoThuocName || khoThuocSelected?.name,
				warehouseId: formValues?.khoThuocId || khoThuocSelected?.id,
				doctorAdvice: formValues?.loiDanBacSi,
				usageTime: formValues?.dotDung,
				usageFrom: formValues?.usageFrom,
				usageTo: formValues?.usageTo,
				reExaminationDate: formValues?.ngayTaiKham
					? new Date(formValues.ngayTaiKham).toISOString()
					: null,
				automaticPrescriptionDate: formValues?.ngayKeTuDong,
				designatedDate: formatDateTime(new Date(), APP_TIMESTAMP_FORMAT),
				patientId: benhNhanDieuTri?.patientId,
				visitId: benhNhanDieuTri?.visitId,
				treatmentDoctorUser: userInfo.sub,
				treatmentDoctorName: userInfo.name,
				designatedPerson: userInfo.name,
				designatedPlace: userInfo?.departments?.[0]?.name,
				orderTypeId: parseInt(ORDER_TYPE_ID.THUOC),
				comorbidity: formValues?.comorbidity,
				provisionalDiagnosis: formValues?.provisionalDiagnosis,
				provisionalDiagnosisName: formValues?.provisionalDiagnosisName,
				diagnosisNonCoded: formValues?.diagnosisNonCoded,
				lstMedicalItemOrder: listThuoc.concat(Array.from(deletedListRef.current.values())),
				autoPrescriptions,
				warehouseType: formValues?.khoThuocType || khoThuocSelected?.warehouseType,
				birthDay: getBirthdayDrugParam(benhNhanDieuTri),
				formCode: REQUEST_FROM.DIEU_TRI,
				medicalItemTypeCode: REQUEST_TYPE.THUOC,
				visitObjectTypeCode: benhNhanDieuTri?.visitObjectTypeCode,
				pid: userMetaData?.personId,
			};
			
			const { data } = itemEdit ? await updateKeThuoc(donThuocRequest) : await fetchKeThuoc(donThuocRequest);
			if (CODE.SUCCESS === data?.code) {
				toast.success(RESPONSE_MESSAGE.ADD.SUCCESS);
				statusChangedEventFunc();
				onClose();
			} else {
				toast.error(getErrorMessage(data));
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const onRowDoubleClick = async (row: ReactTableRowProps<any>) => {
		const rowData = row.original;
		const formValues = formikRef.current?.values;
		const warehouseId = formValues!.khoThuocId ?? khoThuocIdRef.current!.toString();

		const detailSelectedThuoc = await getDrugDetail(
			warehouseId,
			rowData.maThuoc || rowData.medicalItemCode
		);

		if (!detailSelectedThuoc) return;

		formikRef.current?.setValues({
			...formValues,
			...rowData,
			index: row.index,
			tableRowId: rowData.id,
			maThuoc: rowData.medicalItemCode || rowData.maThuoc,
		});

		setThuocSelected({
			id: rowData.idThuoc || rowData.medicalItemId,
			code: rowData.maThuoc || rowData.medicalItemCode,
			name: rowData.tenThuoc,
			actIngName: rowData.hoatChat,
			requestedPrice: rowData.donGia,
			roa: rowData.duongDung,
			unitofMeasureName: rowData.donViTinh,
			atIngName: '',
			packaging: '',
			usageIns: 0,
			ROA: '',
			ROAName: '',
			iventory: detailSelectedThuoc?.iventory - detailSelectedThuoc.peShipment,
			consignment: detailSelectedThuoc.consignment,
			serialNumber: detailSelectedThuoc?.serialNumber,
			materialType: detailSelectedThuoc?.materialType,
			materialTypeName: detailSelectedThuoc?.materialTypeName,
			dosage: detailSelectedThuoc?.dosage,
			salePrice: detailSelectedThuoc?.salePrice,
		});
	};

	const onDeleteThuoc = () => {
		setOpenConfirmDelete(false);
		const rowDelete = rowSelectedRef.current;

		if (rowDelete?.id) {
			deletedListRef.current.set(rowDelete.id, {
				...rowDelete,
				deleted: true,
			});
		}

		const listTemp = tableData.filter((row: ThuocInfo) => row.index !== rowDelete.index);
		setTableData(listTemp.map((row, index) => ({ ...row, index })));
	};

	const getDetailKhoThuocSelected = (id: string) => {
		if (!danhSachKhoThuoc.length || !id) return;
		return danhSachKhoThuoc.find(record => record.id === parseInt(id));
	};

	const columnsActions = {
		Header: (props: any) => (
			<TableCustomHeader<ThuocInfo>
				tableProps={props}
				title={'Thao tác'}
				className="text-center text-light min-w-80px"
			/>
		),
		id: 'actions',
		Cell: ({ ...props }) => (
			<div className="d-flex justify-content-center">
				<CustomIconButton
					variant="edit"
					onClick={() => {
						const row = props.row;
						onRowDoubleClick(row);
					}}
				>
					<i className="bi bi-pencil-square text-navy"></i>
				</CustomIconButton>
				<CustomIconButton
					variant="delete"
					onClick={() => {
						rowSelectedRef.current = {
							...props.row.original,
							index: props.row.index,
						};
						setOpenConfirmDelete(true);
					}}
				>
					<i className="bi bi-trash3-fill text-danger"></i>
				</CustomIconButton>
			</div>
		),
	};

	const getDrugDetail = async (warehouseId: string, drugCode: string) => {
		try {
			const response = await searchVatTu({
				warehouseId,
				materialGroup: LOAI_VAT_TU.THUOC,
				pageIndex: 1,
				pageSize: 1,
				keyword: drugCode,
				isIventoryNoZero: true,
			});
			return response.length ? response[0] : null;
		} catch (error) {
			console.error(error);
			toast.error('Đã có lỗi xảy ra khi lấy thông tin thuốc');
		}
	};

	const handleSetPaymentInfor = async () => {
		const FORM_FIELD_CONFIG = [
			{
				code: "TONG_CHI_PHI",
				name: "Tổng chi phí",
				value: (thongTinChiPhi.tongChiPhi + tongTienDonThuoc) || 0,
				type: "price",
				color: "text-danger"
			},
			{
				code: "BHYT",
				name: "BHYT",
				value: thongTinChiPhi?.bhyt || 0,
				type: "price",
			},
			{
				code: "NGUON_KHAC",
				name: "Nguồn khác",
				value: 0,
				type: "price",
			},
			{
				code: "BENH_NHAN",
				name: "Bệnh nhân",
				value: (thongTinChiPhi.benhNhan + tongTienDonThuoc - thongTinChiPhi.bhyt) || 0,
				type: "price",
			},
			{
				code: "TAM_UNG",
				name: "Tạm ứng",
				value: thongTinChiPhi?.tamUng || 0,
				type: "price",
			},
			{
				code: "DA_THU",
				name: "Đã thu",
				value: thongTinChiPhi?.daThu || 0,
				type: "price",
			},
			{
				code: "MIEN_GIAM",
				name: "Miễn giảm",
				value: thongTinChiPhi?.mienGiam || 0,
				type: "price",
			},
			{
				code: "CON_NO",
				name: Number(getChiPhiThuocValue('CON_DU')) > 0 ? "Còn dư" : "Còn nợ",
				value: Number(getChiPhiThuocValue('CON_DU')) > 0 ? Number(getChiPhiThuocValue('CON_DU')) : Math.abs(tongTienConDu || 0),
				type: "price",
			},
		]
		try {
			let { data: { data } } = await getFormFieldConfig("FORM_INFO_PAYMENT_ASSIGN");
			const jsonObject = JSON.parse(data[0]?.valueText);

			let newArr: any[] = [];
			jsonObject.forEach((item: any) => {
				let obj = FORM_FIELD_CONFIG.find((obj: any) => obj?.code === item);

				newArr.push(obj);
			})

			setPaymentItem(newArr);
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		handleSetPaymentInfor();
	}, [tongTienDonThuoc, thongTinChiPhi]);

	const formatLocalDatetimeToString = (value: Date | null) => {
		if (!value) return '';
		return moment(`${value}Z`).format('YYYY/MM/DD');
	};

	const mapDrugListResponseToTable = (data: any[]) => {
		const result: any[] = [];
		data.forEach((row: any, index: number) => {
			result.push({
				...row,
				id: row.id,
				tenThuoc: row.name,
				hoatChat: row.activeIngredients,
				donVi: row.unit,
				soLuong: row.totalQuantity,
				duongDung: row.route,
				lieuDung: row.dosageForm,
				donGia: row.unitPrice,
				thanhTien: row.intoMoney,
				doiTuong: row.visitObjectTypeName,
				huongDanSuDungThuoc: row.usageInstructions,
				quantityInMorning: row.quantityInMorning,
				quantityInNoon: row.quantityInNoon,
				quantityInAfternoon: row.quantityInAfternoon,
				quantityInEvening: row.quantityInEvening,
				donViTinh: row.unit,
				tongSoThuoc: row.totalQuantity,
				soNgayDung: row.numberOfDays,
				index,
				idThuoc: row.medicalItemId,
				materialType: row.materialType,
				materialTypeName: row.materialTypeName,
				dosageStrength: row.dosageStrength,
				maThuoc: row.medicalItemCode,
				servicePrice: row.svcFee,
				hospitalPrice: row.svcFeeHospital,
				bhytPrice: row.svcFeeIns,
			});
		});
		return result;
	};

	const getDonThuoc = (data: any) => {
		const formData: IThuocModel & { treatmentSheet: any, usageFrom: any, usageTo: any } = {
			id: data.id,
			ghiChu: data.note,
			khoThuocId: data.warehouseId,
			bacSiDieuTri: data.treatmentDoctorName,
			loiDanBacSi: data.doctorAdvice,
			dotDung: data.usageTime,
			ngayTaiKham: formatLocalDatetimeToString(data.reExaminationDate),
			ngayKeTuDong: data.automaticPrescriptionDate,
			ngayYLenh:
				data.doctorOrderDay ?? formatDateTime(new Date(), APP_TIMESTAMP_FORMAT),
			maThuoc: '',
			tenThuoc: '',
			khoThuoc: '',
			provisionalDiagnosis: data.provisionalDiagnosis,
			provisionalDiagnosisName: data.provisionalDiagnosisName,
			comorbidity: data.comorbidity,
			diagnosisNonCoded: data?.diagnosisNonCoded,
			treatmentSheet: {
				id: data?.treatmentSheetId,
				prescriptionDate: data?.treatmentSheetCreatedDate
			},
			usageFrom: data?.usageFrom,
			usageTo: data?.usageTo
		};
		formikRef.current &&
			formikRef.current.setValues({
				...initialFormValues,
				...formData,

			});
		setThuocDetail(data);

		if ((data.lstMedicalItemOrderRes || []).length) {
			const listThuoc: (ThuocInfo & Partial<IThuocModel>)[] =
				mapDrugListResponseToTable(data.lstMedicalItemOrderRes);
			setTableData(listThuoc);
		}
	};

	useEffect(() => {
		itemEdit && getDonThuoc(itemEdit);
	}, [itemEdit]);

	const updateRowData = (rowIndex: number, field: string, value: any) => {
		const tableDataTemp = [...tableData];
		const rowUpdate = tableDataTemp.find((row: any, index: number) => index === rowIndex);
		const editedValue = getCellEditValue({
			rowUpdate,
			field,
			value,
			categories: {
				listDoiTuong: danhSachDanhMuc?.listDoiTuong,
			},
			patientInfo: benhNhanDieuTri,
		});
		const updatedList = tableDataTemp.map((row: any, index) => {
			if (index === rowIndex) {
				return {
				...row,
				...editedValue,
				};
			}
			return row;
		});
		setTableData(updatedList);
  	};


	const handleGetDsPhieuDieuTri = async () => {
		try {
			const { data } = await getDsPhieuDieuTri({
				patientId: benhNhanDieuTri?.patientId,
				visitId: benhNhanDieuTri?.visitId,
				medicalRecordCode: benhNhanDieuTri?.medicalRecordCode,
			});
			if (data?.code === CODE.SUCCESS) {
				setDsPhieuDieuTri(data?.data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (benhNhanDieuTri?.patientId && benhNhanDieuTri?.visitId && benhNhanDieuTri?.medicalRecordCode) handleGetDsPhieuDieuTri();
	}, [benhNhanDieuTri?.patientId, benhNhanDieuTri?.visitId, benhNhanDieuTri?.medicalRecordCode]);

	return (
		<Modal
			className="modal-thuoc page-full"
			fullscreen
			dialogClassName="h-modal"
			show={open}
			backdropClassName="spaces top-50"
		>
			<Formik<any>
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
				innerRef={formikRef}
				initialValues={initialFormValues}
			>
				{({
					setFieldValue,
					values,
					getFieldProps,
					resetForm,
					setValues,
					errors,
					touched,
				}) => (
					<Form className="spaces h-calc-vh-50" ref={formRef}>
						<input type="hidden" {...getFieldProps('index')} />
						<input type="hidden" {...getFieldProps('tableRowId')} />
						<input type="hidden" {...getFieldProps('maThuoc')} />

						<div className="thuoc-dialog h-100">
							<Modal.Header className="py-3 header-modal">
								<HeaderThuoc 
									onClose={onClose}
									tableData={tableData}
									setTableData={setTableData}
									setKhoThuocSelected={setKhoThuocSelected}
									isEdit={!!itemEdit}
								/>
							</Modal.Header>

							<Modal.Body className="py-6 px-0 spaces overflow-hidden spaces h-calc-vh-154">
								<div className="bg-white radius-2 spaces py-10 px-10">
									<div className="d-flex flex-wrap">
										<div className="spaces mb-4">
											<DatePickerCustom
												label="Ngày y lệnh"
												name="ngayYLenh"
												labelClassName="spaces ms-0 min-w-120"
												value={values.ngayYLenh}
												setDateValue={date => {
													setFieldValue('ngayYLenh', date);
												}}
												mode="date-time"
												errors={errors?.ngayYLenh}
												touched={touched?.ngayYLenh}
												disabled
											/>
											<TextField
												label='Người y lệnh'
												name="bacSiDieuTri"
												labelClassName="spaces min-w-120px"
												containerClassName='spaces pt-8'
												disabled
											/>
										</div>
										<div className="spaces position-relative d-flex align-items-start">
											<Button
												className="bg-white py-0 pr-5 mb-3"
												onClick={() => setShouldOpenModalSelectICD10(true)}
											>
												<u className="fw-bold text-pri fs-13px">
													Chọn bệnh
												</u>
											</Button>
											<LabelRequired
												label="Chẩn đoán"
												isRequired
												className="min-w-90px ms-2 lh-xxl"
											/>
										</div>
										<Row className="flex-grow-1 position-relative">
											<ProvisonalDiagnosis
												encounterDiagnosisValues={values}
												encounterDiagnosisErrors={errors}
												encounterDiagnosisTouched={touched}
												listComorbidity={listComorbidity}
												setListComorbidity={setListComorbidity}
												onChange={(data: any) =>
													setValues({
														...values,
														...data,
													})
												}
												handleChangeEncounterDiagnosis={setFieldValue}
											/>
										</Row>
									</div>
									<Row className="spaces mt-4">
										<Col xs={6} className="d-flex">
											<div className="d-flex">
												<LabelRequired
													label="Bệnh kèm theo"
													className="d-inline-block spaces min-w-120-px text-truncate"
												/>
											</div>
											<div className="spaces position-relative w-100">
												<TextField
													className="w-100 d-flex flex-column align-items-start"
													inputClassName="flex-auto spaces radius-3px pre-line"
													name="comorbidity"
													labelClassName="ms-0 min-w-145px"
													// readOnlyText
												/>
											</div>
										</Col>
										<Col xs={6}>
											<TextField
												className="spaces w-100"
												inputClassName="w-100"
												label="Ghi chú"
												name="ghiChu"
												labelClassName="ms-0 min-w-85px"
											/>
										</Col>
									</Row>
									<Row className="spaces mt-4">
										<Col xs={4} className="d-flex">
											<LabelRequired
												label="Kho thuốc"
												className="min-w-120-px"
											/>
											<AutocompleteV2
												options={danhSachKhoThuoc}
												name="khoThuoc"
												value={khoThuocSelected}
												onChange={selectedOption => {
													setKhoThuocSelected(selectedOption);
													setFieldValue('khoThuoc', selectedOption?.code);
													setFieldValue('khoThuocId', selectedOption?.id);
													setFieldValue('khoThuocType', selectedOption?.warehouseType);
													setFieldValue(
														'khoThuocName',
														selectedOption?.name
													);
												}}
												isDisabled={!!tableData.length}
											/>
										</Col>
										<Col sm={4}>
											<div className='d-flex align-items-center'>
												<LabelRequired
													label="Phiếu điều trị:"
													className="spaces min-w-110"
													isRequired
												/>
												<div className="spaces W-200">
													<AutocompleteV2
														options={dsPhieuDieuTri || []}
														getOptionLabel={option => formatDateTime(option?.prescriptionDate) as string}
														value={values?.treatmentSheet || phieuDieuTri}
														name="treatmentSheet"
														onChange={selectedOption => setValues({
															...values,
															treatmentSheet: selectedOption,
															ngayYLenh: formatDateDTO(selectedOption?.prescriptionDate)
														})}
													/>
												</div>
												<Button
													variant='link'
													className='link-info text-decoration-underline spaces py-0 pl-10'
													onClick={() => setOpenPhieuDieuTriDialog(true)}
												>
													Thêm phiếu điều trị
												</Button>
											</div>
										</Col>
										{!itemEdit && (
											<Col xs={4}>
												<NgayKeTuDong name="autoPrescriptions" treatmentId={benhNhanDieuTri?.treatmentId} />
											</Col>
										)}
									</Row>
									<Row className="spaces mt-4">
										<Col xs={2}>
											<OctNumberField
												label="Đợt dùng"
												name="dotDung"
												labelClassName="ms-0 min-w-120-px"
												value={values.dotDung}
												onChange={(value: number) => {
													setFieldValue('dotDung', value);
												}}
											/>
										</Col>
										<Col xs={2}>
											<DatePickerCustom
												label="Từ ngày:"
												name="usageFrom"
												value={values.usageFrom}
												setDateValue={date => setFieldValue('usageFrom', date)}
											/>
										</Col>
										<Col xs={2}>
											<DatePickerCustom
												label="Đến:"
												name="usageTo"
												value={values.usageTo}
												setDateValue={date => setFieldValue('usageTo', date)}
											/>
										</Col>
										<Col xs={6}>
											<TextField
												className="spaces w-100"
												inputClassName="w-100"
												label="Lời dặn BS"
												name="loiDanBacSi"
												labelClassName="ms-0 spaces min-w-85"
											/>
										</Col>
									</Row>
								</div>

								<div className="bg-white radius-2 spaces py-10 px-10 mt-6">
									<Row className="spaces mt-4">
										<Col xs={9} className="position-relative">
											<SelectTableButton
												setThuocSelected={value => {
													onDrugSelect(value);
												}}
												maKhoThuoc={
													values.khoThuocId?.toString() ||
													khoThuocSelected?.id.toString() ||
													''
												}
												label="Tên thuốc"
												labelClassName="min-w-120-px"
												inputValue={values.tenThuoc}
											/>
										</Col>
										<Col>
											<OctNumberField
												inputClassName="w-100"
												label="SL khả dụng"
												name="soLuongKhaDung"
												labelClassName="ms-0 spaces min-w-95"
												value={values.soLuongKhaDung}
												disabled
											/>
										</Col>
										<Col>
											<TextField
												className="spaces w-100"
												inputClassName="w-100"
												label="Đơn vị"
												name="donViTinh"
												labelClassName="ms-0 min-w-56 spaces"
												disabled
											/>
										</Col>
									</Row>
									<Row className="spaces mt-4">
										<Col xs={9} className="d-flex">
											<div className="w-20">
												<OctNumberField
													label="Số ngày"
													name="soNgayDung"
													labelClassName="ms-0 min-w-120-px"
													onBlur={() => {
													    countTongSoLuongThuoc(values);
													}}
													value={values.soNgayDung}
													onChange={(value: number) => {
														setFieldValue('soNgayDung', value);
													}}
												/>
											</div>
											<div className="w-20 ps-5">
												<OctNumberField
													label="Số lượng"
													name="tongSoThuoc"
													labelClassName="ms-0 min-w-80px"
													required
													value={values.tongSoThuoc}
													onChange={(value: number) => {
														setFieldValue('tongSoThuoc', value);
													}}
													error={getIn(errors, 'tongSoThuoc')}
													touched={getIn(touched, 'tongSoThuoc')}
												/>
											</div>
											<InputAutoComplete
												label="Liều dùng"
												name="lieuDung"
												options={LIEU_DUNG_THUOC_OPTIONS}
												placeholder="Liều dùng/lần , Số lần/ngày"
												className="spaces w-100"
												inputClassName="w-100"
												labelClassName="min-w-85 ms-8"
												value={values?.lieuDung ?? ''}
												required
											/>
										</Col>
										<Col xs={3}>
											<TextField
												inputClassName="w-100"
												label="Đường dùng"
												name="duongDung"
												labelClassName="ms-0 min-w-95px"
												disabled
											/>
										</Col>
									</Row>
									<Row className="spaces mt-4 d-flex flex-nowrap">
										<Col xs={5}>
											<InputAutoComplete
												className="spaces w-100"
												inputClassName="w-100"
												label="Hướng dẫn SD"
												name="huongDanSuDungThuoc"
												placeholder="Khoảng cách dùng, thời điểm dùng, lưu ý"
												labelClassName="ms-0 min-w-120 spaces"
												options={HDSD_THUOC_OPTIONS}
											/>
										</Col>
										<Col xs={4} className="spaces d-flex">
											{THOI_DIEM_DUNG_THUOC.map((option: IThoiDiemDung) => (
												<div className="spaces ps-5" key={option.name}>
													<OctNumberField
														label={option.label}
														name={option.name}
														labelClassName="ms-0 min-w-55px"
														onBlur={() => {
														    countTongSoLuongThuoc(values);
														}}
														value={values[option.name]}
														onChange={(value: number) => {
															setFieldValue(option.name, value);
														}}
													/>
												</div>
											))}
										</Col>
										<Col xs={3} className="d-flex justify-content-end">
											<div className="d-flex gap-4">
												<Button className="btn-fill" type="submit">
													<i className="bi bi-check-lg"></i> Xác nhận
												</Button>
												<Button
													className="btn-outline"
													onClick={() => {
														resetForm({
															values: {
																...values,
																...initialThuocInfoValue,
															},
														});
													}}
												>
													<i className="bi bi-x-lg"></i> Hủy bỏ
												</Button>
											</div>
										</Col>
									</Row>
								</div>

								<div className="spaces h-calc-vh-442 bg-white spaces py-10 px-0 radius-2 mt-6 table-ke-thuoc">
									<TableCustom<ThuocInfo>
										data={tableData}
										columns={ThuocColumns}
										maxHeight={300}
										columnsActions={columnsActions}
										tableOptions={{
											updateRowData,
											objectTypes: danhSachDanhMuc?.listDoiTuong,
										}}
									/>
								</div>
								<ICD10
									shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
									setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
									listICD10={danhSachDanhMuc?.listICD10 || []}
									listComorbidity={listComorbidity}
									setListComorbidity={setListComorbidity}
									selectionModeICD10="radio"
									data={values}
									onChange={value =>
										setValues({
											...values,
											...value,
										})
									}
								/>
								{openConfirmDelete && (
									<ConfirmDialog
										className="z-index-1060"
										show={openConfirmDelete}
										title="Thông báo"
										message="Bạn có chắc chắn muốn xóa thuốc này không ?"
										yes="Xác nhận"
										close="Đóng"
										onCloseClick={() => {
											setOpenConfirmDelete(false);
											rowSelectedRef.current = null;
										}}
										onYesClick={onDeleteThuoc}
									/>
								)}
								<ConfirmDialog
									className="z-index-1060"
									show={shouldOpenConfirmDialog}
									title="Thông báo"
									message={validateMessage}
									yes="Có"
									close="Không"
									onCloseClick={() => {
										setValidateMessage("");
										setShouldOpenConfirmDialog(false);
									}}
									onYesClick={() => onSaveForm()}
								/>
								{inventoryValidateMessage && (
									<ConfirmDialog
										className="z-index-1060"
										show={Boolean(inventoryValidateMessage)}
										title="Thông báo"
										message={
											<div>
												<div>Số lượng thuốc kê tự động vượt quá số lượng khả dụng:</div>
												<div className="mt-2">
													{inventoryValidateMessage?.map((msg, index) => (
														<div key={index}>&#8226;&nbsp;{msg}</div>
													))}
												</div>
											</div>
										}
										yes="Đóng"
										onYesClick={() => setInventoryValidateMessage(null)}
										onCloseClick={() => setInventoryValidateMessage(null)}
									/>
								)}
								{openPhieuDieuTriDialog && (
									<PhieuDieuTriDialog
										open={openPhieuDieuTriDialog}
										onClose={() => setOpenPhieuDieuTriDialog(false)}
										callbackFunc={(data: any) => setValues({
											...values,
											treatmentSheet: data,
											ngayYLenh: formatDateDTO(data?.prescriptionDate)
										})}
									/>
								)}
							</Modal.Body>

							<Modal.Footer className="d-flex justify-content-between position-relative spaces bottom-10 px-10 py-4">
								<div className="d-flex align-items-center w-75">
									<div className="border-right h-100 min-w-100 spaces pr-30 d-flex align-items-center justify-content-center flex-column">
										<div className="fw-bold mt-2 text-danger">Tiền đơn</div>
										<div className="text-danger fw-bold text-center">
											{/* {getChiPhiThuocValue('TIEN_DON')} */}
										</div>
									</div>

									<PaymentInfor
										className="w-100 price-info"
										paymentData={paymentItem}
									/>
								</div>

								<div className="d-flex gap-3">
									<Button className="btn-fill" onClick={onSaveForm}>
										<IconButtonSave /> Lưu
									</Button>
								</div>
							</Modal.Footer>
						</div>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default FormChiDinhThuoc;
